import React from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Stats from "@/components/site/Stats";
import PipelineTicker from "@/components/site/PipelineTicker";
import Divisions from "@/components/site/Divisions";
import About from "@/components/site/About";
import Transparency from "@/components/site/Transparency";
import Services from "@/components/site/Services";
import Portfolio from "@/components/site/Portfolio";
import WhyChoose from "@/components/site/WhyChoose";
import Testimonials from "@/components/site/Testimonials";
import Leadership from "@/components/site/Leadership";
import Industries from "@/components/site/Industries";
import CTABand from "@/components/site/CTABand";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

const Home = () => {
  return (
    <main className="relative min-h-screen bg-[#0a0a0a]">
      <Navbar />
      <Hero />
      <PipelineTicker />
      <Stats />
      <Divisions />
      <About />
      <Transparency />
      <Services />
      <Portfolio />
      <WhyChoose />
      <Testimonials />
      <Leadership />
      <Industries />
      <CTABand />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
};

export default Home;
